/**
 * Razorpay checkout script loader, shared by every page that opens a payment
 * popup. The script tag is injected once per session and the promise is cached,
 * so repeated renewals do not re-download it.
 */
export interface RazorpayCheckoutHandle {
  open(): void;
}

export interface RazorpayCheckoutOptions {
  key: string;
  amount: number;
  currency: string;
  name: string;
  description?: string;
  order_id: string;
  handler: (res: { razorpay_payment_id: string }) => void;
  modal?: { ondismiss?: () => void };
}

declare global {
  interface Window {
    Razorpay?: new (o: RazorpayCheckoutOptions) => RazorpayCheckoutHandle;
  }
}

let checkoutScript: Promise<Window['Razorpay']> | null = null;

export function loadCheckout(): Promise<Window['Razorpay']> {
  if (window.Razorpay) return Promise.resolve(window.Razorpay);
  if (!checkoutScript) {
    checkoutScript = new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = 'https://checkout.razorpay.com/v1/checkout.js';
      s.async = true;
      s.onload = () => resolve(window.Razorpay);
      s.onerror = () => reject(new Error('Failed to load Razorpay checkout'));
      document.head.appendChild(s);
    });
  }
  return checkoutScript;
}